<template>
  <el-dialog
    title="批量修改销售范围"
    :visible.sync="salesScopeVisible"
    width="506px"
    :before-close="cancelHandle"
    :append-to-body="true"
  >
    <!-- <el-form :model="priceForm" :rules="priceRules" ref="priceForm">
      <el-form-item label="调价方式：" label-width="120px" prop="salesScopeId">
      </el-form-item>
      <el-form-item label="增幅比例(%)：" label-width="120px">
        <el-input v-model="priceForm.name" placeholder="请输入增幅比例"></el-input>
        <span class="amplification">(1-200)</span>
      </el-form-item>
    </el-form>-->
    <el-radio v-model="salesScope" :label="1">全平台</el-radio>
    <el-radio v-model="salesScope" :label="2">仅协议客户</el-radio>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelHandle">取 消</el-button>
      <el-button type="primary" @click="salesScopeHandle">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    salesScopeVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      salesScope: 1
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {
    cancelHandle() {
      this.$emit('update:salesScopeVisible', false)
    },
    salesScopeHandle() {
      this.$emit('salesScopeHandle', this.salesScope)
    }
  }
}
</script>
<style lang="scss" scoped></style>
